import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/svg/Stopwatch.svg'
import _imports_1 from '@/assets/svg/Alert.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "text-2xl font-bold text-black-main mr-auto mt-auto mb-auto" }
const _hoisted_4 = { class: "text-gray-guide text-xs mt-1" }
const _hoisted_5 = { class: "container my-6" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-lg font-medium text-warning" }
const _hoisted_8 = { class: "my-3 py-2 px-3 bg-warning rounded-md border border-solid border-warning" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "text-xs font-medium text-portal-darkgrey" }
const _hoisted_11 = { class: "my-4 py-4 px-5 rounded-xl bg-black-secondary text-white" }
const _hoisted_12 = { class: "text-xs opacity-70" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "mt-3.5" }
const _hoisted_15 = { class: "text-xs opacity-70" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "mt-3.5" }
const _hoisted_18 = { class: "text-xs opacity-70" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = {
  key: 0,
  class: "text-portal-darkgrey text-xs"
}
const _hoisted_21 = { class: "container my-6" }
const _hoisted_22 = { class: "text-xs text-portal-grey" }
const _hoisted_23 = { class: "my-2 rounded-md" }
const _hoisted_24 = { class: "text-xl" }
const _hoisted_25 = { class: "container my-6" }
const _hoisted_26 = { class: "text-xs text-portal-grey" }
const _hoisted_27 = { class: "my-2 p-3 rounded-md bg-detail text-black-secondary" }
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = { class: "text-xl font-bold" }
const _hoisted_30 = { class: "circle copy-icon" }
const _hoisted_31 = { class: "text-xs text-portal-darkgrey text-right" }
const _hoisted_32 = { class: "text-xs text-portal-grey" }
const _hoisted_33 = { class: "my-2 p-3 rounded-md bg-detail text-black-secondary" }
const _hoisted_34 = { class: "text-sm leading-normal font-bold break-words" }
const _hoisted_35 = { class: "flex flex-row-reverse mt-4" }
const _hoisted_36 = { class: "circle copy-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsButton = _resolveComponent("CpsButton")!
  const _component_CpsGuideModal = _resolveComponent("CpsGuideModal")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_ctx.machineContext)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("Deposit_Detail")), 1),
          _createElementVNode("button", {
            class: "flex flex-col items-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowGuideModal = true))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("Deposit_Guide")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              class: "h-auto outline-none max-w-full pr-1",
              src: _imports_0
            }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.countdown), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                class: "h-auto outline-none max-w-full pr-1 self-start",
                src: _imports_1
              }, null, -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("Deposit_Detail_Tips")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t("Deposit_Transaction_Id")), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.machineContext.ticketId), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t("Deposit_Transaction_Date")), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.offetTime), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.fromCurrecnyName) + "/" + _toDisplayString(_ctx.toCurrencyName), 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.amountFormat(6)(_ctx.rate)), 1)
            ])
          ])
        ]),
        (_ctx.isShowKVND)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.t("Deposit_Show_VND_Rate")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.t("Deposit_Transfer_Network")), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.TokenStandards[_ctx.machineContext.tokenStandard]), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.t("Deposit_Transfer_Amount")) + " " + _toDisplayString(_ctx.fromCurrecnyName), 1),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.amountFormat(8)(_ctx.machineContext.fromAmount)), 1),
              _withDirectives(_createElementVNode("button", _hoisted_30, null, 512), [
                [_directive_clipboard, _ctx.amountFormat(8)(_ctx.machineContext.fromAmount), "copy"],
                [_directive_clipboard, _ctx.prompt.copySuccess, "success"]
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.t("Deposit_Estimate")) + " " + _toDisplayString(_ctx.amountFormat(2)(_ctx.toAmount)) + " " + _toDisplayString(_ctx.toCurrencyName), 1),
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.t("Deposit_Wallet_Address")), 1),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.machineContext.toAddress), 1),
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("button", _hoisted_36, null, 512), [
                [_directive_clipboard, _ctx.machineContext.toAddress, "copy"],
                [_directive_clipboard, _ctx.prompt.copySuccess, "success"]
              ]),
              _createElementVNode("button", {
                class: "circle scan-icon mr-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onQrCode && _ctx.onQrCode(...args)))
              })
            ])
          ])
        ]),
        _createVNode(_component_CpsButton, {
          class: "w-full",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("Deposit_Enter_Hash_Id")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_CpsGuideModal, {
          isShowModal: _ctx.isShowGuideModal,
          guideContent: _ctx.guideContent,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowGuideModal = false))
        }, null, 8, ["isShowModal", "guideContent"])
      ]))
    : _createCommentVNode("", true)
}